import mixpanelData from "./mixpanel";

export const makeSideBarActive = (menu: { icon: string, title: string, url: string, active: boolean }[], index: number) => {
  menu.map((item) => item.active = false);
  menu[index].active = true;
  return menu
}


export const getMilliSec = (date: any) => {
  return new Date(date).getTime()
}

export const getMilliSecUTC = (date: any) => {
  let Adate = new Date(date)
  return  Date.UTC(Adate.getFullYear(),Adate.getMonth(),Adate.getDate())
 }

export const convertMilliSecToDateNew = (date: any) => {
  if (date) {
      try 
      { return new Date(date).toDateString() }
      catch {
          return ''
      }
  } else {
      return ''
  }
}

export const checkCandidateStatus = (data: number| string) => {
  switch (data) {
    case 5:
      return { name: 'F3 - Verified', id: '5' }
    case 6:
      return { name: 'F99 - Rejected', id: '6' }
    case 7:
      return {name:'F100- Blacklisted',id:'7'}
  }
}

export const checkSourcedBy = (data: string) => {
  switch (data) {
    case 'RECRUITER':
      return 'Recruiter'
    case 'PROVIDER':
      return 'Provider'
  }
}

export const preferenceCheck = (data: any) => {
  if (data && data.salary) {
    if (data.salary.billingType && data.salary.currencyType && data.salary.expectedPay) {
      return true
    }
    else {
      return false
    }
  }
}

export const detailedProfileCompletion = (data: any) => {

  if (data) {
    if (data.firstName && data.lastName && data.email && data.phoneNumber && data.country && data.workExp && data.jobRole && data.jobRole.length > 0) {
      return true
    }
    else {
      return false
    }
  }
}


export const checkFunctionality = (field:string,data: any) => {
  
  
  if (field === 'availabilityValue') {
   return checkAvailability(data,0)
  }

  if (field === 'priority'){
    return  checkPriority(data)
  }
  if(field === 'allocated_to'){
   return data
  }
  if(field === 'allocatedTo'){
      return data
  } 
}


export const checkPriority = (data: any) => {
  
  
  switch (data) {
    
    case '3':
      return 'Hot'
    
    case '2':
      return 'Warm'
    
    case '1':
      return 'Cold'
    
    case 1:
      return 'Cold'
    
    case 2:
      return 'Warm'
    
    case 3:
      return 'Hot'
    
   
  }
}

export const checkcompanySize = (data: number) => {
  switch (data) {
    case 0:
      return '1-10'
    case 1:
      return '11-50' 
    case 2:
      return '51-250'
    case 3:
      return '251-10k'
    case 4:
      return '10k+'
    
  }
}

export const checkRemote = (data: number) => {
  switch (data) {
    case 0:
      return 'Yes'
    case 1:
      return 'No'
 }

}

export const checkSize = (size: number) => {
  switch (size) {
    case 0:
      return { id: 0, name: '0-10' }
    case 1:
      return { id: 1, name: '10-50' }
    case 2:
      return { id: 2, name: '50-100' }
}
}

export const checkAvailability = (data: any, date?: number | Date | undefined) => {
      
  switch (data && data.availability) {
    case 1: 
     return 'Immediately'
    case 2:    
      let newDate :any = data.availability_date ? new Date(parseInt(data.availability_date)).toDateString().slice(3) : 'coming date'    
      return `I’m getting relieved from my current job by ${newDate}`
    case 3:
      let weeks: any = data.availability_week ? data.availability_week : 'coming'
      return `In ${weeks} weeks after I get the offer`
    case 4:
      return 'Unavailable for jobs'
    case 5:
        let startDate: any = data.contractStartDate ? new Date(parseInt(data.contractStartDate)).toDateString().slice(3) : 'NA'
        let endDate:any = data.contractEndDate ? new Date(parseInt(data.contractEndDate)).toDateString().slice(3) : 'NA'
        return `In Contract(${startDate} - ${endDate})`
    default:
      return 'Not Mentioned'
  }
}

export const availablityInFilter = (data: any) => {
      
  switch (data) {
    case 1: 
     return 'Immediately'
    case 2:    
      return 'Coming date'
    case 3:
      return 'Coming weeks'
    case 4:
      return 'Unavailable for jobs'
    case 5:
      return 'In Contract'
    default:
      return 'Not Mentioned'
  }
}





export const checkJobType = (data:number) => {
switch(data) {
  case 1: 
  return 'Freelancer'
   case 2:
   return 'Contract'
  case 3:
   return 'Full Time'
}

}

export const checkCompanyType = (data: number) => {
  switch (data) {
    case 1:
     return 'Hirer'

    case 2:
      return 'Provider'
    
    case 3:
      return 'Both'
      
  }
}

export const priorityClass = (data: number | string) => {
  
  switch (data) {
    
    case 1:
      return 'priorityLow'
    
    case 2:
      return 'priorityMedium'
    
    case 3:
      return 'priorityHigh'
    case '1':
      return 'priorityLow'
    
    case '2':
      return 'priorityMedium'
    
    case '3':
      return 'priorityHigh'

  }
}



export const timeSince = (date: any) => {
  let d: any = new Date(+date);
  let val: any = new Date()
  let seconds = Math.floor((val - d) / 1000);

  let interval = seconds / 31536000;

  if (interval > 1) {
      return Math.floor(interval) === 1 ? Math.floor(interval) + ' year ago' : Math.floor(interval) + " Years ago";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
      return Math.floor(interval) === 1 ? Math.floor(interval) + ' month ago' : Math.floor(interval) + " months ago";
  }
  interval = seconds / 86400;
  if (interval > 1) {
      return Math.floor(interval) === 1 ? Math.floor(interval) + ' day ago' : Math.floor(interval) + " days ago";
  }
  interval = seconds / 3600;
  if (interval > 1) {
      return Math.floor(interval) === 1 ? Math.floor(interval) + ' hour ago' : Math.floor(interval) + " hours ago";
  }
  interval = seconds / 60;
  if (interval > 1) {
      return Math.floor(interval) === 1 ? Math.floor(interval) + ' minute ago' : Math.floor(interval) + " minutes ago";
  }
  return Math.floor(interval) === 1 ? Math.floor(seconds) + ' second ago' : Math.floor(seconds) + " seconds ago";
}

var a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ',
    'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
var b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];


export const inWords = (num:any) => {
  if ((num = num.toString()).length > 9) return 'Limit Exceeds';
  let n:any = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return; var str = '';
  str += (n[1] !== 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
  str += (n[2] !== 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
  str += (n[3] !== 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
  str += (n[4] !== 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
  str += (n[5] !== 0) ? ((str !== '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only! ' : '';
  return str;
}

export const workexperience = (value: number, type: number) => {
  let data = value.toString()
  return data.split('.')[type] || 0
}

export const checkActive = (status: number) => {
  switch (status) {
    case 4:
      return 'active'
    case 5:
      return 'danger'
    case 6:
      return 'danger'
    case 7:
      return 'danger'
  }
}

export const checkStatus = (status: number) => {
  switch (status) {
    case 7:
      return 'Enable'
    case 4:
      return 'Disable'
  }
}

export const checkLevel = (level: number) => {
  switch (level) {
    case 1:
      return {
        title: 'Level 1 Developer',
        summary: 'A person with coding and unit testing experience'
      }
    case 2:
      return {
        title: 'Level 2 Developer',
        summary: 'A person with experience in designing along with coding and testing and can perform code reviews with ease.'
      }
      case 3:
        return {
          title: 'Level 3 Developer',
          summary: 'A person experienced in Designing, code reviewing, and mentoring junior developers'
      }
      case 4:
        return {
          title: 'Level 4 Developer',
          summary: 'A person experienced in Managing the team and assigning tasks along with excellent designing and coding skills.'
        }
  }
}


export const skillNameConverter = (data: any) => {

  let value = data.map((item: any) => {
    let response = {
      skillId: item.id,
      skillName: item.name
    }
    return response
  })
  return value
}

export const checkUserActiveStatus = (status: number) => {
  switch (status) {
    case 1:
      return 'Basic Registration'
    case 2:
      return 'Full Registration'
    case 3:
      return 'Call scheduled'
    case 4:
      return 'Approved'
    case 5:
      return 'Rejected'
    case 6:
      return 'Disabled as company is rejected'
    case 7:
      return 'Disabled'
    case 8:
      return 'Deleted'
  }
}

export const checkTimesheetStatus = (status: string) => {
  switch (status) {
    case '1':
      return {
        value: 'Draft',
        class: 'statusMessage Yellow'
      }
    case '2':
      return {
        value: 'Submitted',
        class: 'statusMessage Yellow'
      }
    case '3':
      return {
        value: 'Approved',
        class: 'statusMessage Green'
      }
    case '4':
      return {
        value: 'Rejected',
        class: 'statusMessage Red'
    }
    default:
      return {
        value: '',
        class: ''
    }
  }
}

export const mixpanelEvents = (data: any) => {
  switch (data && data.type) {
    case 'availability':
      mixpanelData('ML-Availabilty submitted', {
        'source': 'Provider updates availablity of the resource',
        'Availablity': availablityInFilter(data.availability && data.availability.availabilityId),
        'distinct_id': localStorage.getItem('Email'),

      })
      return;
    case 'Personal Details':
      mixpanelData('ML-Personal details submitted', {
        'source': 'Provider submits persoanl details of a resource',
        'country': data.country,
        'designation': data.designation,
        'email': data.email,
        'firstName': data.firstName,
        'jobRoles': data.jobRoles && data.jobRoles.toString(),
        'lastName': data.lastName,
        'nationality': data.nationality,
        'phoneNumber': data.phoneNumber,
        'workExperience': data.workExperience,
        'distinct_id': localStorage.getItem('Email'),

      })
      return;
    case 'Preferences':
      mixpanelData('ML-Preferences submitted', {
        'source': 'Provider submits preference of a resource',
        'billingType': data.preference && data.preference.salary && data.preference.salary.billingType,
        'currencyType': data.preference && data.preference.salary && data.preference.salary.currencyType,
        'expectedPay': data.preference && data.preference.salary && data.preference.salary.expectedPay,
        'distinct_id': localStorage.getItem('Email'),

      })
      return;
  }
}

export const checkAvailabilitymixpanel = (data: number | undefined, date: number | Date | undefined) => {
  switch (data) {
    case 1: 
     return 'Immediately'
    case 2:
      let newDate: any = new Date(date ? date : '')
      return `I’m getting relieved from my current job by ${newDate} date`
    case 3:
      return `In ${date} weeks after I get the offer`
    case 5:
      return 'Unavailable for jobs'
  }
}
